module.exports = __webpack_public_path__ + "media/seher_1.1b.c8d492a7.mp3";